import React from "react";

export default function NavTitle({ title, subtitle = null }) {
  return (
    <>
      <div className="edu_counter_main_section_wrapper parallax-bg z-n1 ">
        <div className="edu_counter_img_overlay"></div>
        <div className="container">
          <div class="row w-100 z-3 text-center">
            <div class="col-md-12 z-3">
              <h1
                class=" text-white"
                style={{
                  fontFamily: "'Playfair Display', serif",
                }}
              >
                {title}
              </h1>
              <p
                class="custom-sous-titre-h2 text-white"
                style={{ letterSpacing: "0.5rem" }}
              >
                {subtitle}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
